// extracted by mini-css-extract-plugin
export default {"cls1":"styles-cls1__c7a9cef0f8110f3cbe9a","cls2":"styles-cls2___f610ed2d2e6d5800d1d styles-cls1__c7a9cef0f8110f3cbe9a"};